import * as React from "react";
import { SessionTypes } from "../../misc/api/ApiSessionTypes";
import { DeviceTypes, SessionScheduleAction } from "../../misc/api/apiTypes";
import { ScheduleSession } from "./VisitSchedule";

interface SessionScheduleActionContextState {
    actions: SessionScheduleAction[];
    setActions: React.Dispatch<React.SetStateAction<SessionScheduleAction[]>>;
}

const SessionScheduleActionContext = React.createContext<SessionScheduleActionContextState | undefined>(undefined);

interface SessionScheduleActionContextProps {
    sessionItem: ScheduleSession;
    children: React.ReactNode;
}

export const SessionScheduleActionContextProvider = ({ sessionItem, children }: SessionScheduleActionContextProps) => {
    const [actions, setActions] = React.useState<SessionScheduleAction[]>([]);

    React.useEffect(() => {
        const getData = async () => {
            if (sessionItem?.deviceType === DeviceTypes.In2itiveP230EDiary) {
                setActions(sessionItem.eDiary.actions.map(a => ({
                    Id: a.id,
                    ActionType: a.actionType,
                    ActionValue: a.actionValue,
                    DisplayOrder: a.displayOrder,
                })));
            }
        }

        getData();
    }, [sessionItem]);

    return (
        <SessionScheduleActionContext.Provider value={{ actions, setActions }}>
            {children}
        </SessionScheduleActionContext.Provider>
    );
}

export const useSessionScheduleActionContext = (): SessionScheduleActionContextState => {
    const context = React.useContext(SessionScheduleActionContext);
    if (context === undefined) {
        throw new Error('useSessionScheduleActionContext must be used within a SessionScheduleActionContext Provider');
    }

    return context;
}
